import { Holiday } from '../holidays';

export const USA_HOLIDAYS: Record<number, Holiday[]> = {
    2024: [
        { name: "New Year's", date: new Date(2024, 0, 1) },
        { name: "MLK Day", date: new Date(2024, 0, 15) },
        { name: "Presidents Day", date: new Date(2024, 1, 19) },
        { name: "Memorial Day", date: new Date(2024, 4, 27) },
        { name: "Independence", date: new Date(2024, 6, 4) },
        { name: "Labor Day", date: new Date(2024, 8, 2) },
        { name: "Columbus Day", date: new Date(2024, 9, 14) },
        { name: "Veterans Day", date: new Date(2024, 10, 11) },
        { name: "Thanksgiving", date: new Date(2024, 10, 28) },
        { name: "Christmas", date: new Date(2024, 11, 25) }
    ],
    2025: [
        { name: "New Year's", date: new Date(2025, 0, 1) },
        { name: "MLK Day", date: new Date(2025, 0, 20) },
        { name: "Presidents Day", date: new Date(2025, 1, 17) },
        { name: "Memorial Day", date: new Date(2025, 4, 26) },
        { name: "Independence", date: new Date(2025, 6, 4) },
        { name: "Labor Day", date: new Date(2025, 8, 1) },
        { name: "Columbus Day", date: new Date(2025, 9, 13) },
        { name: "Veterans Day", date: new Date(2025, 10, 11) },
        { name: "Thanksgiving", date: new Date(2025, 10, 27) },
        { name: "Christmas", date: new Date(2025, 11, 25) }
    ],
    2026: [
        { name: "New Year's", date: new Date(2026, 0, 1) },
        { name: "MLK Day", date: new Date(2026, 0, 19) },
        { name: "Presidents Day", date: new Date(2026, 1, 16) },
        { name: "Memorial Day", date: new Date(2026, 4, 25) },
        { name: "Independence", date: new Date(2026, 6, 4) },
        { name: "Labor Day", date: new Date(2026, 8, 7) },
        { name: "Columbus Day", date: new Date(2026, 9, 12) },
        { name: "Veterans Day", date: new Date(2026, 10, 11) },
        { name: "Thanksgiving", date: new Date(2026, 10, 26) },
        { name: "Christmas", date: new Date(2026, 11, 25) }
    ]
};
